<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.bulk_edit_selected_items }}</h2>
      <div class="innerContent">
        <!-- 카테고리 -->
        <div class="mb15 isRequired">
          <div class="innerTitle setLabel">{{locale.category}}</div>
          <div class="infoGroup">
            <button class="btn input" :disabled="shopOptIds.length > 0" @click="openShopCategory">{{ locale.category_setting }}</button>
            <button type="button" class="btn btnDarkWhite" @click="checkCategory([], true)">{{ locale.clear }}</button>
          </div>
          <p v-if="shopOptIds.length > 0" class="colorRed">옵션상품은 카테고리 변경이 불가합니다.</p>
        </div>
        <!-- //카테고리 -->
        <!-- 이용 가능 시간 -->
        <div class="mb15">
          <div class="innerTitle setLabel">
            {{locale.usage_time}}
          </div>
          <div v-if="preset.availableTime.length > 0" class="infoGroup">
            <select v-model="value.availableTime" class="input select">
              <option value="">{{locale.not_setting}}</option>
              <option
                v-for="(item, index) in preset.availableTime"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <button type="button" class="btn btnDarkWhite" @click.stop="apply('availableTime')">{{ locale.apply_bulk }}</button>
          </div>
          <div v-else class="input">{{locale.no_preset}}</div>
        </div>
        <!-- //이용 가능 시간 -->
        <!-- 읽기전용 이용시간 -->
        <div class="mb15">
          <div class="innerTitle setLabel">
            {{locale.readonly_usage_time}}
          </div>
          <div v-if="preset.availableTime.length > 0" class="infoGroup">
            <select v-model="value.displayTime" class="input select">
              <option value="">{{locale.not_setting}}</option>
              <option
                v-for="(item, index) in preset.availableTime"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <button type="button" class="btn btnDarkWhite" @click.stop="apply('displayTime')">{{ locale.apply_bulk }}</button>
          </div>
          <div v-else class="input">{{locale.no_preset}}</div>
        </div>
        <!-- //읽기전용 이용시간 -->
        <!-- 프로모션 -->
        <div class="mb15">
          <div class="innerTitle setLabel">
            {{locale.promotion}}
          </div>
          <div v-if="preset.promotions.length > 0" class="infoGroup">
            <div class="promotionList">
              <div class="checkbox"
                v-for="(item, index) in preset.promotions"
                :key="index">
                <input
                  type="checkbox"
                  name="item_promotion"
                  :id="`promotion_${item.presetId}`"
                  :value="item.presetId"
                  v-model="value.promotions">
                <label
                  :for="`promotion_${item.presetId}`">
                  {{ item.presetName }}
                </label>
              </div>
            </div>
            <button type="button" class="btn btnDarkWhite" @click.stop="apply('promotions')">{{ locale.apply_bulk }}</button>
          </div>
          <div v-else class="input">{{locale.no_preset}}</div>
        </div>
        <!-- //프로모션 -->
        <!-- 판매불가 표시 -->
        <div class="mb15">
          <div class="innerTitle setLabel">
            {{locale.disabled_mark}}
          </div>
          <div v-if="preset.status.length > 0" class="infoGroup">
            <select v-model="value.status" class="input select">
              <option value="">{{locale.not_select}}</option>
              <option
                v-for="(item, index) in preset.status"
                :key="index"
                :value="item.presetId">
                {{ item.presetName }}
              </option>
            </select>
            <button type="button" class="btn btnDarkWhite" @click.stop="apply('status')">{{ locale.apply_bulk }}</button>
          </div>
          <div v-else class="input">{{locale.no_preset}}</div>
        </div>
        <!-- //판매불가 표시 -->
        <!-- 카테고리 -->

        <!-- //카테고리 -->
      </div>

      <div v-if="inProgress" class="progressBox">
        <p>{{ locale.bulk_configuring_items }} ({{ locale.total }} {{ shopItemIds.length }})</p>
        <div class="progressBar mt15">
          <span class="progressPer">{{ done }}/{{ total }} ({{ `${progressPercent}%` }})</span>
          <div :style="{ width: progressPercent + '%' }" class="bar"></div>
        </div>
        <!-- <details v-if="logs.length" class="mt10">
          <summary>log ({{ logs.length }})</summary>
          <ul>
            <li v-for="(line, i) in logs" :key="i">{{ line }}</li>
          </ul>
        </details>
        <details v-if="errors.length" class="mt10 colorRed">
          <summary>error ({{ errors.length }})</summary>
          <ul>
            <li v-for="e in errors" :key="e.id">{{ e.shopItemId }}: {{ e.message }}</li>
          </ul>
        </details> -->
        <div v-if="progressPercent === 100" class="btns">
          <button type="button" class="btn sizeM" @click="complete">{{ locale.confirm }}</button>
        </div>
      </div>


    </div>

    <!-- 카테고리 설정 -->
    <ShopCategory v-if="shopCategory"
      :locale="locale"
      :id="shopPageId"
      :isSelect="true"
      :category="categoryList"
      :defaultLang="defaultLang"
      :checkedIds="checkedIds"
      @checkCategory="checkCategory"
      @apply="checkCategory"
      @close="closeShopCategory" />
    <!-- //카테고리 설정 -->
  </div>
</template>

<script>
import ShopCategory from './ShopCategory'

export default {
  name: 'SetBulkItems',
  props: [
    'locale',
    'shopPageId',
    'shopItemIds',
    'shopOptIds',
    'defaultLang',
    'categoryList',
    'checkedIds'
  ],
  components: {
    ShopCategory
  },
  computed: {
    progressPercent () {
      return this.total ? Math.round((this.done / this.total) * 100) : 0
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      value: {
        availableTime: '',
        displayTime: '',
        promotions: [],
        status: '',
        category: [],
      },
      preset: {
        availableTime: [],
        promotions: [],
        status: []
      },
      inProgress: false, // 진행상태
      shopCategory: false,
      total: 0,
      done: 0,
      errors: [],
      logs: [],
      concurrency: 4 // 서버 보호/속도 균형용 동시 실행 개수
    }
  },
  methods: {
    async init () {
      this.$store.commit('onLoading', true)
      if (this.$route.params.categoryId !== 'unknown') {
        this.value.category.push(this.$route.params.categoryId)
      }
      await this.getAvailableTimePreset()
      await this.getPromotionPreset()
      await this.getStatusPreset()
      this.$store.commit('onLoading', false)
    },
    async getAvailableTimePreset () {
      const getAvailableTime = await this.$store.dispatch('shop/getShopPresetList', 'availableTime')
      const availableTimeList = getAvailableTime && getAvailableTime.message && getAvailableTime.message.preset
      if (availableTimeList) {
        this.preset.availableTime = availableTimeList
      }
      return getAvailableTime
    },
    async getPromotionPreset () {
      const getPromotion = await this.$store.dispatch('shop/getShopPresetList', 'promotion')
      const promotionList = getPromotion && getPromotion.message && getPromotion.message.preset
      if (promotionList) {
        this.preset.promotions = promotionList
      }
      return getPromotion
    },
    async getStatusPreset () {
      const getStatus = await this.$store.dispatch('shop/getShopPresetList', 'status')
      const statusList = getStatus && getStatus.message && getStatus.message.preset
      if (statusList) {
        this.preset.status = statusList
      }
      return getStatus
    },
    openShopCategory () {
      this.shopCategory = true
    },
    closeShopCategory () {
      this.shopCategory = false
    },
    checkCategory (ids, continueApply) {
      this.value.category = ids
      this.apply('category')
    },
    apply (key) {
      if (window.confirm(this.locale.confirm_apply)) {
        const value = this.value[key]
        const data = {
          key: key,
          value: value
        }
        this.applyBulk(data)
      }
    },
    updateItem (itemData, updateData) {
      const updateKey = updateData.key
      const updateValue = updateData.value
      // 프리셋 데이터는 presetId+presetName으로 받지만 저장할 때는 presetId만 보냄
      if (itemData.availableTime?.presetId) itemData.availableTime = itemData.availableTime.presetId
      if (itemData.displayTime) itemData.displayTime = itemData.displayTime
      if (itemData.status?.presetId) itemData.status = itemData.status.presetId
      if (itemData.descList) itemData.descList = itemData.descList.map(desc => desc.presetId || desc.desc && { desc: desc.desc })
      itemData.category = (itemData.category || []).map(cate => cate.categoryId)
      if (updateKey && updateValue) {
        itemData[updateKey] = updateValue
      } else {
        // 데이터가 없으면 빈값 말고 객체를 delete
        delete itemData[updateKey]
      }
      return itemData
    },
    complete () {
      this.$emit('complete')
    },
    // 체크한 shopItemId만큼 업데이트 처리
    async applyBulk (updateData) {
      this.inProgress = true
      this.total = this.shopItemIds.length
      this.done = 0
      this.errors = []
      this.logs = []

      await this.runWithConcurrency(
        this.shopItemIds,
        (shopItemId) => this.processOne(shopItemId, updateData),
        this.concurrency
      )

      // 프로그레스바까지 모두 정상 업데이트 되는 것을 기다림
      await this.$nextTick()
      await new Promise(r => requestAnimationFrame(() => requestAnimationFrame(r)))
      await new Promise(r => setTimeout(r, 0))

      alert(this.locale.complete_save)
      this.value = {
        availableTime: '',
        displayTime: '',
        promotions: [],
        status: '',
        category: []
      }
      this.value.category.push(this.$route.params.categoryId)
    },
    // 개별 아이템 처리 워커: get -> merge -> save
    async processOne (shopItemId, updateData) {
      try {
        this.logs.push(`#${shopItemId}: 호출시작`)
        const getData = {
          pageId: this.shopPageId,
          shopItemId: shopItemId
        }
        const getItem = await this.$store.dispatch('shop/getShopItem', getData)
        if (!getItem?.message?.shopItemId) throw new Error(getItem?.message?.code || 'fail - GET')

        const updateItem = this.updateItem(getItem.message, updateData)

        this.logs.push(`#${shopItemId}: 저장시작`)
        const setItem = await this.$store.dispatch('shop/updateShopItem', updateItem)
        if (setItem?.status !== 200) throw new Error(setItem?.message?.code || 'fail - UPDATE')

        return { shopItemId, ok: true }
      } catch (e) {
        const msg = e?.message || String(e)
        this.errors.push({ shopItemId, message: msg })
        this.logs.push(`#${shopItemId}: fail - ${msg}`)
        return { shopItemId, ok: false, error: e }
      } finally {
        // 저장 성공/실패와 무관하게 "한 아이템 처리 완료"로 집계
        this.done++
      }
    },
    // 간단한 concurrency runner
    async runWithConcurrency (shopItemIds, worker, limit = 4) {
      if (limit <= 1) {
        // 순차 처리
        for (const shopItemId of shopItemIds) {
          await worker(shopItemId)
        }
        return
      }
      // 작업 인덱스 공유
      let index = 0
      const runners = new Array(Math.min(limit, shopItemIds.length)).fill(0).map(async () => {
        while (true) {
          let myIndex
          // 인덱스 안전 증가
          if (index >= shopItemIds.length) break
          myIndex = index
          index++

          const shopItemId = shopItemIds[myIndex]
          await worker(shopItemId)
        }
      })
      await Promise.allSettled(runners)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
.infoGroup {
  display: flex;
  column-gap: 12px;
  .input {
    flex: 1;
    width: auto;
  }
  .btn {
    min-width: 90px;
    margin-left: auto;
    padding-left: 12px;
    padding-right: 12px;
    white-space: nowrap;
    align-self: flex-start;
  }
}
.promotionList {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  .checkbox {
    width: 50%;
    margin: 0;
  }
}
.progressBox {
  padding: 12px;
  border-radius: 4px;
  background-color: $color-white;
  .btns {
    margin: 15px 0;
  }
}
.progressBar {
  position: relative;
  height: 24px;
  background: $color-lgrey2;
  border-radius: 4px;
  overflow: hidden;
  .progressPer {
    position: absolute;
    top: 50%;
    left: 50%;
    font: 12px sans-serif;
    transform: translate(-50%, -50%);
    z-index: 1;
  }
  .bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: $color-blue;
    background-image: linear-gradient(to right, #b3fafc, #4d59cc);
  }
}
</style>